export const PRIME_LANDING_PAGE_URL = "prime";
export const MY_PRIME_AREA_URL = "travel/profile/#user_area/";
